<template>
    <div>
        <div class="pheadcontainer">
            <span style="font-size: 30px" class="phead">Our Clubs</span>
        </div>
        <hr />
        <br /><br />
        <div class="clubs">
            <router-link to="/clubs/business">
                <clubItem img="business" name="Business and Entreprenuership" desc="The business and entrepreneurship club is a community for young minds who have a curiosity for the business world." />
            </router-link>
            <router-link to="/clubs/psychology">
                <clubItem img="psychology" name="Psychology Club" desc="The Psychology club offers opportunities to meet other students interested in psychology, get involved in mental health seminars, discussions and activities." />
            </router-link>
            <clubItem img="dance" name="Dance Club" desc="The dance club is a place for talented dancers to learn and discuss about dancing." />
            <clubItem img="debate" name="Debate Club" desc="The debate club is a place for all minds interested to enter the world of public speaking and debating." />
            <clubItem img="photography" name="Photography Club" desc="A photo represents a memory you wish to never forget. The photography clubs constitutes of members full of memories and dreams." />
            <clubItem img="writing" name="Creative Writing Club" desc="Writing is a way to express one's feelings. The creative writing club is a place for writers across the nation." />
            <clubItem img="reading" name="Book Club" desc="The book club is a group of active readers who love to discuss new books, stories, and poems." />
            
            <!-- <clubItem img="computer" name="Computer Club" desc="The computer club provides a safe haven for the technical minds of our generation." />
            <clubItem img="gaming" name="Gaming Club" desc="Gaming allows us to enter a virtual world full of hope and opportunities. The gaming club is a team of gamers who love to experience new games." />
            <clubItem img="design" name="Art Club" desc="Art represents the emotions of an artist. The art club is a group of talented artists who wish to paint the world from their emotions." /> -->
        </div>
        <p>More clubs coming soon...</p>
    </div>

</template>

<script>

import clubItem from '@/components/ClubItem.vue'
export default {
    components: {
        clubItem
    },
    mounted() {
        window.scrollTo({top: 0, behavior: "smooth"});
        // for (let i = 0; i < document.querySelectorAll(".club-item").length; i++) {
        //     let currentClub = document.querySelectorAll(".club-item")[i]
        //     currentClub.addEventListener("click", ()=> {
        //         alert(currentClub.children[1].innerText.split(' ')[0])
        //     })
        // }
    }
}
</script>